import { socket } from '../..';
import { store } from '@shared/redux';
import { dialogsListApi } from '@shared/api';
import {
  getCachedDialogFromList,
  getCachedDialogOrganizations,
  getDialogListOrganizationId,
} from './cache-scope';

export const handleLeadCreated = () => {
  return socket.onMessage('LEAD_CREATED', (payload) => {
    const clientId = payload.client_id;
    const leadCreatedAt = payload.lead_created_at;

    const state = store.getState();
    const cachedGetListDialogsDialogListPostArgs = dialogsListApi.util.selectCachedArgsForQuery(
      state,
      'getListDialogsDialogListPostQuery',
    );

    const dialogByOrganizationId = getCachedDialogOrganizations(state, clientId);

    cachedGetListDialogsDialogListPostArgs?.forEach((args) => {
      const filteredChannels = args?.dialogListFilters?.channel_ids;
      const filterLead = args?.dialogListFilters?.is_lead === true;
      const hasSearch = Boolean((args?.dialogListFilters as { q?: string } | undefined)?.q);
      const organizationId = getDialogListOrganizationId(args);
      const dialogFromCache = organizationId
        ? (dialogByOrganizationId.get(organizationId) ?? null)
        : null;
      const cachedDialog = getCachedDialogFromList(state, args, clientId);
      const channelId = cachedDialog?.channel_id ?? dialogFromCache?.channel_id ?? null;

      if (!cachedDialog && !dialogFromCache) return;

      if (
        Array.isArray(filteredChannels) &&
        filteredChannels.length &&
        channelId &&
        !filteredChannels.includes(channelId)
      ) {
        return;
      }

      store.dispatch(
        dialogsListApi.util.updateQueryData('getListDialogsDialogListPostQuery', args, (draft) => {
          if (!draft.items) return;

          const currentIndex = draft.items.findIndex((dialog) => dialog.client_id === clientId);
          const currentDialog = currentIndex >= 0 ? draft.items[currentIndex] : null;

          if (currentDialog) {
            currentDialog.lead_created_at = leadCreatedAt;
            return;
          }

          if (!filterLead || hasSearch || !dialogFromCache) return;

          const nextDialog = {
            ...dialogFromCache,
            lead_created_at: leadCreatedAt,
          };

          draft.items = [nextDialog, ...draft.items].sort((a, b) =>
            b.last_message_at.localeCompare(a.last_message_at),
          );
          draft.count =
            draft.count !== undefined && draft.count !== null
              ? draft.count + 1
              : draft.items.length;
        }),
      );
    });
  });
};
